import { useEffect } from 'react';
import { useColumnFilterRegistryContext } from '../context/useColumnFilterRegistryContext';

// Safari bug workaround: closing the overlay when focus is stuck on the header (boolean filters) doesn't move focus
// so we refocus the trigger ourselves. Esc otherwise closes the overlay;
// PrimeReact already does it when focus is inside the overlay or on the trigger, so we only act in the remaining case.
export const useColumnFilterCloseShortcut = (columnName: string) => {
  const { closeColumnFilter, getTriggerElement } =
    useColumnFilterRegistryContext();

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key !== 'Escape' || event.defaultPrevented) return;

      event.preventDefault();

      const target = event.target as HTMLElement | null;
      if (target?.closest('.p-column-filter-overlay')) return;

      const trigger = getTriggerElement(columnName);
      if (target === trigger) return;

      const isOwnSortableHeader =
        target === trigger?.closest('[data-p-sortable-column="true"]');

      closeColumnFilter(columnName);
      if (isOwnSortableHeader) trigger?.focus();
    };

    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [closeColumnFilter, columnName, getTriggerElement]);
};
